<template>
    <div class="view" :style="{paddingTop:navbarheight}">
        <div class="content">
            <my-top title="用车申请" lefttext="返回" righttext="申请记录" @rightclick="togo('/application/travelApplication/list')"  @leftclick="handlePreLayer()"></my-top>
            <Form ref="form">
                <cell-group class="cellgroup">
                    <div class="base">
                        <cell title="申请单位" :value="form.unitName"></cell>
                        <cell title="申请部门" :value="form.departmentName"></cell>
                        <cell title="申请人" :value="form.personName"></cell>
                    </div>
                    <div class="formWrap">
                        <div class="title"><span style="color: red;font-weight: normal">*</span>通知手机</div>
                        <div class="formCtn">
                            <van-field v-model="form.phone"
                                       type="textarea"
                                       rows="1"
                                       autosize
                                       :rules="[{ pattern, message: '请输入正确的电话号码' }]"
                                       placeholder="请输入" />
                        </div>
                        <div class="formCtn fileToCell">
                            <van-field
                                    label="开始时间"
                                    ref='goTime'
                                    v-model="form.goTime" readonly
                                    :rules="[{ required: true }]"
                                    placeholder="开始时间"  @click="handleStarTime('goTime')" />
                        </div>
                        <div class="formCtn fileToCell">
                            <van-field
                                    label="结束时间"
                                    ref='comeTime'
                                    v-model="form.comeTime" readonly
                                    :rules="[{ required: true }]"
                                    placeholder="结束时间" @click="handleStarTime('comeTime')" />
                        </div>
                        <div class="title"><span style="color: red;font-weight: normal">*</span>目的地</div>
                        <div class="formCtn">
                            <van-field v-model="form.address"
                                       rows="2"
                                       autosize
                                       show-word-limit
                                       type="textarea"
                                       :rules="[{ required: true }]"
                                       maxlength="30"
                                       placeholder="请输入" />
                        </div>
                        <div class="title"><span style="color: red;font-weight: normal">*</span>车型要求</div>
                        <div class="formCtn">
                            <van-field v-model="form.requirement"
                                       type="textarea"
                                       rows="1"
                                       autosize
                                       show-word-limit
                                       maxlength="30"
                                       :rules="[{ required: true }]"
                                       placeholder="请输入" />
                        </div>
                        <div>
                            <cell title="用车人员">
                                <template #title>
                                    <div><span style="color: red;font-weight: normal">*</span>用车人员</div>
                                </template>
                                <template>
                                    <van-button :disabled="loadingSub" style="padding: 0 0.5rem;" plain type="info"  icon="plus" size="mini" @click="togo('/application/travelApplication/selectPeople', {form:form, baseInfo:baseInfo, usePersonName:usePersonName, id:id})">选择</van-button>
                                </template>
                            </cell>
                        </div>
                        <div class="formCtn form-cell box">
                            <template v-if="!loadingSub">
                                <Badge v-for="(item, index) in usePersonName"
                                       @click.native="deleteCur(index, item)"
                                       style="margin:0 1.5rem 1.5rem 0; z-index: 10;" color="#595959">
                                    <span class="spanBtn" plain type="default" size="small">{{item}}</span>
                                    <template #content>
                                        <Icon name="cross" class="badge-icon" />
                                    </template>
                                </Badge>
                            </template>
                            <template v-else>
                                <van-button  v-for="(item, index) in usePersonName" plain type="default" size="small">{{item}}</van-button>
                            </template>
                        </div>
                        <div class="title"><span style="color: red;font-weight: normal">*</span>事由</div>
                        <cell-group class="cellgroup">
                            <div class="formWrap">
                                <div class="formCtn">
                                    <van-field v-model="form.subjectMatter"
                                               rows="3"
                                               autosize
                                               show-word-limit
                                               type="textarea"
                                               :rules="[{ required: true }]"
                                               maxlength="300"
                                               placeholder="请输入" />
                                </div>
                            </div>
                        </cell-group>
                    </div>
                </cell-group>
                <div style="margin: 16px;">
                    <div class="btn">
                        <van-button type="info" native-type="submit" :loading="loadingSub" loading-text="提交中..." @click="handleSubmit()">提交</van-button>
                    </div>
                </div>
            </Form>
            <!--时间-->
            <popup v-model="timeVisible" round position="bottom">
                <datetime-picker
                        v-model="currentDate"
                        type="datehour"
                        @cancel="timeVisible = false"
                        @confirm="hanldeDatetime"/>
            </popup>
        </div>
    </div>
</template>

<script>
    import {
        Badge,
        Cell,
        CellGroup,
        Checkbox,
        CheckboxGroup,
        DatetimePicker,
        Dialog,
        Divider,
        Form,
        Icon,
        Loading,
        NavBar,
        Overlay,
        Picker,
        Popup,
        Radio,
        RadioGroup
    } from "vant";
    import UploadList from "@components/UploadListVant/index.vue";
    import application from "@api/application";

    export default {
        name: "addScenenRecord",
        components: {Cell,Popup,Picker,CellGroup,CheckboxGroup,Checkbox,NavBar,DatetimePicker,Form, RadioGroup, Radio,Divider,Loading,UploadList,Overlay,Badge,Icon,Dialog},
        data() {
            return {
                pattern:/^1[3456789]\d{9}$/,
                loadingSub:false,
                timeVisible:false,
                id: this.$route.query.id || '', //列表ID
                projectId: this.$store.state.project.projectId || [],
                usePersonName: this.$route.query?.usePersonName || [],
                currentDate:new Date(),
                editModel: this.$route.query.editModel, //编辑状态
                form:{
                    status: 1,
                    personName:JSON.parse(localStorage.getItem("vuex")).user?.userInfo?.name,
                    departmentName: JSON.parse(localStorage.getItem("vuex")).user?.company?.deptName,
                    level: JSON.parse(localStorage.getItem("vuex")).user?.company?.code,
                    unitName: JSON.parse(localStorage.getItem("vuex")).user?.company?.code === 'PD' ? JSON.parse(localStorage.getItem("vuex")).user?.posts?.oname +'/'+JSON.parse(localStorage.getItem("vuex")).user?.company?.name : JSON.parse(localStorage.getItem("vuex")).user?.company?.name,
                     //项目部 PD 分公司 BC 公司 CO
                    unitId: JSON.parse(localStorage.getItem("vuex")).user?.company?.id,
                    phone: JSON.parse(localStorage.getItem("vuex")).user?.userInfo?.phone,
                    usePersonId: [],
                    subjectMatter:'',
                    requirement:'',
                    goTime:'',
                    comeTime:'',
                },
                baseInfo: this.$route.query.baseInfo //存储编辑时的详情数据
            }
        },
        watch: {},
        methods:{
            deleteCur(index, item){
                this.usePersonName.splice(index,1);
                this.form.usePersonId.splice(index,1);
            },
            /**
             *开始时间/结束时间
             * @param val：开始时间/结束时间
             */
            handleStarTime(val){
                this.timeStatus=val;
                this.timeVisible =true
            },
            /**
             *提交时间
             */
            hanldeDatetime(val){
                this.timeVisible = false;
                let time = this.formatTime(val);
                if( this.timeStatus === 'goTime'){
                    //获取开始时间
                    this.form.goTime = time
                    this.BlurTime(time)
                }else if(this.timeStatus === 'comeTime'){
                    //获取结束时间
                    this.form.comeTime = time
                    this.BlurTime(time)
                }
            },
            BlurTime(time){
                if( this.timeStatus === 'goTime'){
                    //获取开始时间
                    if(this.form.comeTime !== '' && this.form.goTime >= this.form.comeTime){
                        this.form.goTime = '';
                        this.$toast('开始时间小于结束时间')
                    }else {
                        this.form.goTime = time;
                    }
                }else if(this.timeStatus === 'comeTime'){
                    //获取结束时间
                    if(this.form.goTime !== '' && this.form.goTime >= this.form.comeTime){
                        this.form.comeTime = '';
                        this.$toast('开始时间小于结束时间')
                    }else {
                        this.form.comeTime = time;
                    }
                }
            },
            /**
             *验证必填项目
             */
            validate(){
                let status=true;
                for (let item in this.form) {
                    if(!this.form[item] || this.form[item].length === 0){
                        this.$toast('请填写完整')
                        status = false
                    }else if(item === 'phone'){
                        var reg=/^1[3456789]\d{9}$/;
                        if(!reg.test(this.form[item])){
                            this.$toast('请输入正确的手机号码');
                            status = false
                        }
                    }
                }
                return status
            },
            /**
             * '新增保存/提交'
             * @param auditStatus: 旁站状态:DRAFT草稿；SUBMITTED提交,可用值:DRAFT,SUBMITTED,PAST,REJECTED
             */
            handleSubmit(){
                if(!this.validate()){
                    return false
                }
                Dialog.confirm({
                    message: '请确认是否要提交用车申请？',
                }).then(() => {
                    if(!this.id){
                        let api=application.addCarApply;
                        const params = {
                            ...this.form,
                            usePersonId:this.form.usePersonId.toString()
                        }
                        this.handleCreate(params, api)
                    }else {
                        const params = {
                            ...this.baseInfo,
                            ...this.form,
                            usePersonId:this.form.usePersonId.toString(),
                            status:1
                        }
                        let api=application.addCarApplyAgain;
                        this.handleCreate(params, api)
                    }
                })
            },
            handleCreate(params, api){
                this.loadingSub = true;
                api(params).then(res=> {
                    if(res.code === '0'){
                        this.$toast('提交成功！');
                        this.$router.push({
                            path:'/application/travelApplication/detail',
                            query:{
                                id: this.id || res.data.id
                            }
                        })
                        this.loadingSub = false
                    }
                }).catch(() => {
                    this.loadingSub = false
                })
            },
            handlePreLayer(){
                Dialog.confirm({
                    message: '返回将不保存已填写信息，是否确定返回？',
                }).then(() => {
                    this.$router.push({
                        path:'/application'
                    })
                })
            }
        },
        mounted(){
            if(this.editModel === '2'){
                application.carApplyDetail({id:this.id}).then(res=>{
                    if(res.code === '0'){
                        this.baseInfo =res.data;
                        const { personName, address, departmentName, level, unitName,unitId,phone, usePersonId, subjectMatter, requirement, goTime, comeTime, usePersonNames} = res.data;
                        this.usePersonName= usePersonNames?.split(';')
                        this.form={
                            status: 1,
                            personName: personName,
                            address: address,
                            departmentName: departmentName,
                            level: level || JSON.parse(localStorage.getItem("vuex")).user?.company?.code,
                            unitName: unitName,
                            unitId: unitId,
                            phone: phone,
                            usePersonId: usePersonId.split(','),
                            subjectMatter: subjectMatter,
                            requirement: requirement,
                            goTime: goTime,
                            comeTime: comeTime,
                        }
                    }
                });
            }else {
                this.form={
                    ...this.form,
                    ...this.$route.query.form
                }
                this.id= this.$route.query.id || ''
            }


            // }
        },
    }
</script>

<style  lang="scss" scoped>

    .loadingLabelStyle{
        color:red;
        borderColor:red
    }
    .view{
        background-color: #FFFFFF;
        .content{
            padding-bottom: 5rem;
            .van-cell-group__title{
                background-color: #f5f5f5;
            }
        }
        .cellgroup.van-hairline--top-bottom::after{
            border:none
        }
        .cellgroup {
            .base{
                .van-cell__title{
                    flex: 0.3;
                }
            }
            .formWrap.formCheck{
                .van-radio-group{
                    .van-cell-group.van-hairline--top-bottom{
                        .van-cell.van-cell--clickable{
                            background-color: #f2f2f2;
                            margin-top: 5px;
                            border-radius:4px;
                        }

                    }
                    .van-radio{
                        /*height:45px;*/
                        /*background-color: #f1f1f1;*/
                        /*margin-top: 8px;*/
                        /*padding: 0 10px;*/
                        /*border-radius: 4px;*/
                    }
                    ::v-deep .van-radio__icon.van-radio__icon--round{
                        /*float: right;*/
                    }
                    .van-radio__label{

                    }
                }
            }
            .formWrap{
                .title{
                    padding:1rem 1.6rem;
                    font-size: 14px;
                    line-height: 24px;
                    .van-tag{
                        margin-left: 5px;
                    }
                }
                .formCtn, .formCtn.fileToCell{
                    padding: 0 1.6rem 1rem;
                    border-bottom: 0.1rem solid #f5f6f7;
                    .van-field {
                        padding: 0;
                        &.sideStandVal.van-cell--required::before {
                            left: 10.4rem;
                        }
                        &.van-cell--required::before {
                            z-index: 2;
                        }
                    }
                    ::v-deep .van-field__value{
                        background-color: #f2f2f2;
                        border-radius: 4px;
                        padding: 1.5rem 1rem 1.5rem 1.6rem;
                    }
                    ::v-deep .van-field--error .van-field__control, .van-field--error .van-field__control::placeholder{
                        background-color: #FFF9E8;
                    }
                    ::v-deep .van-field--error .van-field__value{
                        background-color: #FFF9E8;
                    }
                }
                .formCtn.form-field{
                    display: flex;
                    padding: 1rem 1.6rem;
                    .van-field:first-child{
                        margin-right: 5px;
                    }
                    .van-field:last-child{
                        margin-left: 5px;
                    }
                }
                .formCtn.form-cell.box{
                        /*background-color: #f2f2f2;*/
                        padding: 1.5rem 1rem 1.5rem 1.6rem;
                        margin: 0 1rem 0 1.6rem;
                        min-height: 52px;
                        background-color: #f2f2f2;
                        border-radius: 0.4rem;
                    button{
                            margin-right: 5px;
                            padding: 0 0.8rem;
                            margin-bottom: 0.8rem;
                            span.close{
                                padding: 0 0.8rem 0 0.8rem;
                                color: #1989fa;
                            }
                        }
                    .van-cell{
                        background-color: #f2f2f2;
                        border-radius: 4px;
                        ::v-deep .van-field__right-icon{
                            position: absolute;
                            right: 10px;
                        }
                    }
                    ::v-deep .van-field__clear, .van-field__right-icon{
                        margin-right: 0;
                    }
                }
                .formCtn.fileToCell{
                    padding:0.3rem 1.6rem;
                    ::v-deep .van-cell__title {
                        color: #323233;
                        line-height: 4.2rem;
                    }
                    ::v-deep .van-field__value{
                        background-color: transparent;
                        text-align: right;
                    }
                    ::v-deep .van-field__value .van-field__control{
                        background-color: transparent;
                        text-align: right;
                    }
                }

            }

        }
        ::v-deep .navbar .van-nav-bar__right .van-nav-bar__text{
            color:#018FE0;
        }
        .btn {
            > .van-button {
                /*margin: 0 10px;*/
                /*border-radius:4px;*/
            }
        }

    }
    ::v-deep .van-field__label::before{
        content:'*';
        color:#f00
    }
    .badge-icon {
        display: block;
        font-size: 10px;
        line-height: 18px;
    }
    .spanBtn{
        display: inline-block;
        padding: 1rem 1.6rem;
        border: #ebedf0;
        background-color: #ffffff;
    }
</style>